import {
  DatiSessioneUtente,
  RichiestaModuloDTOPermessiItem,
} from '@framework/api-client';
import { SubmissionModuleLogic } from '../..';
import { isManager } from '../delegation/DelegationMachine';
import { IModuleStateMachineRecord } from './ModuleStateMachine';
import { SubmissionModuleState } from './SubmissionModuleState';
import { hasActionPermission } from './hasActionPermission';

export function isModuleWithoutSignAndFullControl(
  record: IModuleStateMachineRecord,
  user: DatiSessioneUtente | null | undefined,
) {
  if (!record.module) return false;
  if (!record.submission) return false;
  const state = record.module.stato;

  return (
    (state === SubmissionModuleState.Completed ||
      state === SubmissionModuleState.Compilation) &&
    !SubmissionModuleLogic.needSign(record.module, record.submission, user) &&
    isManager(record.delegationData, user) &&
    hasActionPermission(record, RichiestaModuloDTOPermessiItem.COMPILAZIONE)
  );
}
